import { render, staticRenderFns } from "./specialPassenger.vue?vue&type=template&id=5381f4fe&"
import script from "./specialPassenger.vue?vue&type=script&lang=js&"
export * from "./specialPassenger.vue?vue&type=script&lang=js&"
import style0 from "./specialPassenger.vue?vue&type=style&index=0&id=5381f4fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports